import styled from '@emotion/styled';
import { DeleteAction } from './DeleteAction';
import { DownloadAction } from './DownloadAction';

const Container = styled.div`
    display: flex;
    flex-direction: row;
    gap: 32px;
`;

export const Actions = () => {
    return (
        <Container>
            <DownloadAction />
            <DeleteAction />
        </Container>
    );
};
